




































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';
import ApiHelper from 'api-helper';
import moment from 'moment';
import 'vue2-datepicker/index.css';
import DatePicker from 'vue2-datepicker';
import Toast from '@common/helpers/toast';
import { PLAN_PAYMENT_TYPE } from '@common/constants/plan';
import { Order } from '@/models/order';
import { get } from 'lodash';

@Component({
  components: {
    DatePicker,
  },
  data() {
    return {
      PLAN_PAYMENT_TYPE,
    };
  },
})
export default class ModalMakeDelivery extends Vue {
  @Prop(Object) readonly order: Order;

  private isSaving = false;
  private form: {
    delivery_date: string | null;
    amount: number | string | null;
  } = {
    delivery_date: null,
    amount: null,
  };

  private get amountErrorMessage() {
    return {
      max_value: '金額はプランの値以下の値を入力してください',
    };
  }

  private get formRef() {
    return this.$refs.formMakeDelivery as any;
  }

  private get minimumDeliveryDate() {
    const nowJst = moment().utcOffset(9);
    const cutoff = nowJst
      .clone()
      .set({ hour: 12, minute: 30, second: 0, millisecond: 0 });
    const daysToAdd = nowJst.isSameOrAfter(cutoff) ? 11 : 10;
    return moment().add(daysToAdd, 'days');
  }

  private get formattedDeliveryDate() {
    return this.form.delivery_date
      ? moment(this.form.delivery_date).format('YYYY/MM/DD')
      : '-';
  }

  private get formattedAmount() {
    return this.form.amount !== null && this.form.amount !== ''
      ? `${Number(this.form.amount).toLocaleString('ja-JP')}円`
      : '-';
  }

  private showModal() {
    const lastTrackingAmount = get(this.order, 'tracking.length')
      ? get(this.order, 'tracking')[get(this.order, 'tracking').length - 1]
          .amount ?? null
      : null;

    this.form = {
      delivery_date: this.minimumDeliveryDate.format('YYYY-MM-DD HH:mm:ss'),
      amount: lastTrackingAmount,
    };

    this.$modal.show('modalMakeDelivery');
  }

  private hideModal() {
    this.$modal.hide('modalMakeDelivery');
  }

  private showConfirmModal() {
    this.$modal.show('modalConfirmMakeDelivery');
  }

  private hideConfirmModal() {
    this.$modal.hide('modalConfirmMakeDelivery');
  }

  private resetForm() {
    this.hideConfirmModal();
    this.form = {
      delivery_date: null,
      amount: null,
    };
    this.isSaving = false;
  }

  private async save() {
    const isValid = await this.formRef?.validate();
    if (!isValid || this.isSaving) {
      return;
    }

    this.showConfirmModal();
  }

  private confirmSave() {
    this.isSaving = true;

    ApiHelper.getApi('OrderChangeApi')
      .makeDelivery(this.order.id, this.form)
      .then(() => {
        Toast.success('保存しました');
        this.hideConfirmModal();
        this.hideModal();
        this.$emit('fetchOrder');
      })
      .catch((error: any) => {
        if (error.response && error.response.data) {
          if (error.response.data.errors) {
            this.formRef.setErrors(error.response.data.errors);
          }
          Toast.error(
            error.response.data.message || '予期しないエラーが発生しました',
          );
        } else {
          Toast.error('通信に失敗しました');
        }
      })
      .finally(() => {
        this.isSaving = false;
      });
  }

  private disabledDeliveryDate(date) {
    return date < this.minimumDeliveryDate.startOf('day').toDate();
  }
}
